export class ListCredentialFindingsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "credentialFindings",
            "baseName": "credentialFindings",
            "type": "Array<CredentialFinding>",
            "format": ""
        },
        {
            "name": "pagination",
            "baseName": "pagination",
            "type": "Pagination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListCredentialFindingsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
